import React from "react";

type LoadingSpinnerProps = {
  size?: "sm" | "md" | "lg";
  message?: string;
};

const LoadingSpinner = ({
  size = "md",
  message = "Carregando...",
}: LoadingSpinnerProps) => {
  const sizeClasses = {
    sm: "spinner-border-sm",
    md: "",
    lg: "spinner-border spinner-border-lg",
  };

  return (
    <div className="d-flex flex-column align-items-center justify-content-center py-5">
      <div
        className={`spinner-border text-primary ${sizeClasses[size]}`}
        role="status"
      >
        <span className="visually-hidden">Carregando...</span>
      </div>
      {message && <p className="mt-3 text-muted">{message}</p>}
    </div>
  );
};

export default LoadingSpinner;
